import React from "react";

export default function AcceptableUsePage() {

  return <iframe src="https://app.termly.io/policy-viewer/policy.html?policyUUID=75881f0f-ff27-4fc0-93b5-2031b8fe3436"
                 width="100%"
                 height="4000px" />

}